// src/pages/About.js
import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function About() {
  return (
    <div className="flex flex-col min-h-screen text-white bg-gradient-to-b from-pink-900 via-purple-900 to-black relative">
      <Navbar />

      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20 z-0"
        style={{ backgroundImage: 'url("/nails.jpeg")' }}
      ></div>

      {/* Main Content */}
      <main className="relative z-10 flex flex-col items-center px-6 py-24 max-w-5xl mx-auto">
        <h1 className="text-6xl font-extrabold text-pink-400 mb-8 text-center drop-shadow-lg">
          About LisaNails 💅
        </h1>

        <p className="text-lg text-white/90 leading-relaxed mb-8 text-center max-w-3xl">
          What started as a simple self-care hobby soon became a full-blown passion.  
          Lisa first began designing press-on nails in her dorm room during college 
          experimenting with colors, finishes, and tiny hand-painted details for friends 
          who wanted salon-quality looks without the hassle or cost.
        </p>

        <p className="text-lg text-white/90 leading-relaxed mb-8 text-center max-w-3xl">
          As word spread and requests started pouring in, Lisa realized how much confidence 
          and joy a beautiful set of nails could bring to someone’s day. That’s when she 
          decided to turn her creative outlet into something bigger a business built on 
          artistry, self-expression, and convenience.
        </p>

        <p className="text-lg text-white/90 leading-relaxed mb-12 text-center max-w-3xl">
          Today, <span className="text-pink-300 font-semibold">LisaNails</span> is more than 
          just a brand it’s a community of people who love expressing themselves through 
          their nails. Each set is crafted with care, precision, and a personal touch, 
          whether you’re choosing a ready-made design or creating something entirely your own.
        </p>

        {/* Highlight Section */}
        <div className="bg-white/10 backdrop-blur-md rounded-2xl shadow-lg p-10 text-center max-w-4xl mb-16">
          <h2 className="text-3xl font-bold text-pink-400 mb-4">
            “Confidence starts at your fingertips.”
          </h2>
          <p className="text-white/90">
            Our mission is simple — to help you feel confident, bold, and beautiful, 
            one nail at a time. From delicate charm details to bold designs, we 
            believe every nail set tells a story — your story.
          </p>
        </div>

        {/* Lisa's Journey / Image Section */}
        <div className="flex flex-col lg:flex-row items-center gap-10 mb-20">
          <img
            src="/Lisa.jpg"
            alt="Lisa working on designs"
            className="w-full lg:w-1/2 h-[400px] object-cover rounded-xl shadow-xl"
          />
          <div className="lg:w-1/2">
            <h3 className="text-3xl font-bold text-pink-300 mb-4">
              The Creative Behind LisaNails 🎨
            </h3>
            <p className="text-white/90 leading-relaxed">
              Lisa’s journey began with curiosity and creativity — trying out nail designs 
              on herself and her friends during study breaks. Every design became more than 
              just decoration; it was a form of art and expression.  
              <br />
              <br />
              What began at a small desk surrounded by glitter, charms, and brushes 
              is now a growing brand.
            </p>
          </div>
        </div>

        {/* Closing Note */}
        <div className="text-center">
          <p className="text-lg text-white/80 italic mb-4">
            “Every nail set is made with care, love, and a little sparkle.”
          </p>
          <p className="text-pink-300 font-semibold">
            — LisaNails 💕
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}
